<template>
  <div class="monitorPage">
    <div class="monitorDetail">
      <van-cell-group class="forestInput">
        <!-- 监测点名称 -->
        <van-field v-model="baseData.name" readonly label="监测点名称：" />
        <van-field
          v-model="baseData.xianName"
          readonly
          :label="$t('common.politicalTit') + '：'"
        />
        <!-- <van-field v-model="baseData.area" readonly label="单位：" /> -->
        <van-field
          v-model="baseData.manger"
          readonly
          :label="$t('common.administratorTit') + '：'"
        />

        <van-field
          v-model="baseData.remarks"
          rows="3"
          autosize
          type="textarea"
          readonly
          :label="$t('common.explainTit') + '：'"
        />
      </van-cell-group>
      <div class="videoPage" v-if="showVideoType">
        <h4 class="ggTit clearfix">
          视频监测 
        </h4>
        <!-- <span class="fr" @click="jumpUrl">全屏</span> -->
        <div class="videoBox" v-if="showVedio">
          <LivePlayer
            :videoUrl="videoUrl"
            autoplay
            :hide-fullscreen-button="clientType == 'android' ? true : false"
            live
            alt
            playsinline
            webkit-playsinline
            x5-playsinline
            x-webkit-airplay="allow"
            class="mb10 mySelfVideo"
          ></LivePlayer>
        </div>
      </div>
      <div class="sensorPage" v-if="collectionList && collectionList[0]">
        <h4 class="ggTit">传感器监测</h4>
        <div class="sensorBox">
          <ul class="clearfix">
            <li
              v-for="(item, index) in collectionList"
              :key="index"
              class="sensorItem fl"
              @click="openLineChart(item)"
            >
              <p>{{ item.name }}</p>
              <p>
                <span
                  >{{ item.data }} <em>{{ item.unit }}</em></span
                >
              </p>
              <p>{{ item.createTime }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 折线图 -->
    <div v-if="linerChartShow" class="linePopup">
      <p class="closeBtn" @click="closeLinerChart"><van-icon name="close" /></p>
      <div class="chartPage">
        <p class="chartTit">{{ sensorTypeName }}：最近24小时数据</p>

        <div class="linerMain">
          <p class="ydw">
            单位{{ sensorUnitType ? "（" + sensorUnitType + "）" : "" }}
          </p>
          <p class="xdw">单位（h）</p>
          <ve-line
            :data="chartData"
            :init-options="initOptions"
            :settings="chartSettings"
            :extend="chartExtend"
            :height="lineHeight"
          ></ve-line>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
// import videojs from "video.js";
// import "videojs-contrib-hls";
import LivePlayer from "@liveqing/liveplayer";
import nonePng from "@/assets/none.png";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
import { Websokit } from "@/api/config";
export default {
  name: "monitorPage",
  components: { LivePlayer },
  data() {
    this.chartDataZoom = [{ type: "slider" }];
    this.chartExtend = {
      legend: {
        //抬头
        show: false,
      },

      xAxis: {
        type: "category",
        boundaryGap: true,

        axisLine: {
          show: true,
          lineStyle: {
            color: "#999",
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
            },
          },
        },
      },
      yAxis: {
        axisLabel: {
          textStyle: {
            color: "#333",
            fontSize: 14,
          },
        },
        axisLine: {
          show: false,
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: "dashed",
          },
        },
      },
    };
    this.chartSettings = {
      area: true, //是否显示为面积图
      yAxisType: "linear",
      itemStyle: {
        //面积图颜色设置
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          // normal: {
          //   //设置折线折点
          //   color: "#FFDB9B",
          // },
          colorStops: [
            {
              offset: 0,
              color: "rgba(255, 167, 10, 1)", // 0% 处的颜色
            },
            {
              offset: 0.5,
              color: "rgba(255, 167, 10, .8)", // 100% 处的颜色
            },
            {
              offset: 0.7,
              color: "rgba(255, 167, 10, .5)", // 100% 处的颜色
            },
            {
              offset: 1,
              color: "rgba(255, 167, 10, .2)", // 100% 处的颜色
            },
          ],
          // globalCoord: false
        },
      },
    };
    this.initOptions = {
      renderer: "svg",
    };
    return {
      baseUrl: process.env.BASE_URL,
      nonePng: nonePng, //默认图片
      treeObjid: "",
      monitorId: "",
      sourceMonitorId: "",
      baseData: {},
      videoUrl: "",
      userToken: "",
      refreshPage: false, //网络失败
      showNonePage: false,
      showVideoType: true,
      showVedio: false,
      myVideo: null,
      playData: {},
      loadingNum: 0,
      collectionList: [],
      reuseHs: null, //执行函数
      timer: null, //执行函数
      linerChartShow: false, //折线图是否显示
      chartData: {
        //数据
        columns: [],
        rows: [],
      },

      sensorTypeName: "",
      sensorUnitType: "",
      lineWidth: "365px", //宽度
      lineHeight: "350px", //高度
      clientType: getDeviceType(), //手机类型
    };
  },
  props: {
    param: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  mounted() {
    this.userToken = this.$route.query.token;
    this.$nextTick(function () {
      this.monitorId = this.$route.query.commonId;
      if (this.monitorId == undefined) {
        this.lineWidth = "365px"; //宽度
        this.lineHeight = "350px"; //高度
        this.monitorId = this.param.id;
      }
      this.getMonitorDetail();
      this.fristConnect();
    });
  },
  methods: {
    fristConnect() {
      var _this = this;
      let deviceDate = Date.parse(new Date());
      var opts = {
        query: "device=" + deviceDate,
        transports: ["websocket", "xhr-polling", "jsonp-polling"],
      };
      _this.socket = window.io.connect(Websokit, opts);

      // console.log(typeof _this.socket)
    },
    getMonitorDetail() {
      let _this = this;
      _this.$api.universal
        .geoMonitor({
          objid: _this.monitorId,
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.baseData = Object.assign({}, _this.baseData, res.data);
            if (res.data.register) {
              _this.getVideoUrl(res.data.register);
              _this.connect(res.data.register);
            } else {
              _this.showVideoType = false;
              _this.showVedio = false;
            }
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          this.refreshPage = true;
          console.log(err);
        });
    },
    getVideoUrl(device) {
      //ios回调m3u8  安卓回调flv
      let _this = this;

      _this.$api.universal
        .monitordeviceMsg({
          device: device,
          type: _this.clientType == "android" ? "webRtc" : "m3u8",
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            if (res.data) {
              _this.showVideoType = true;
              // _this.showVedio = true;
              // _this.videoUrl = res.data;
              _this.showVedio = res.data.videoUrl ? true : false;
              _this.videoUrl = res.data.isOnline ? res.data.videoUrl : null;
            } else {
              _this.showVideoType = false;
              _this.showVedio = false;
            }
          }
        })
        .catch((err) => {
          _this.showVideoType = false;
          _this.showVedio = false;
          console.log(err);
        });
    },
    connect(device) {
      var _this = this;
      var sendMsg = {
        device: device,
      };
      _this.socket.on("connect", function (data) {
        console.log("连接成功");
      });
      console.log(device, "device");
      _this.socket.emit("text", sendMsg);

      _this.socket.on("push_event", function (data) {
        // for (let i in data) {
        //   if (_this.num == 1) {
        //     _this.collectionList.push(data[i]);
        //   } else {
        //     let arr = _this.collectionList;
        //     arr.forEach((item, index) => {
        //       if (item.key == i) {
        //         _this.$set(_this.collectionList[index], "data", data[i].data);
        //         _this.$set(
        //           _this.collectionList[index],
        //           "createTime",
        //           data[i].createTime
        //         );
        //       }
        //     });
        //   }
        // }
        // _this.num++;
        let pushObj = {};
        pushObj = data;

        if (pushObj.device == device) {
          _this.$nextTick(() => {
            if (pushObj.source == "init") {
              //第一次给全部数据

              _this.collectionList = []; //初始化前置空
              for (let i in pushObj.data) {
                _this.collectionList.push(pushObj.data[i]);
              }
            } else if (pushObj.source == "normal") {
              //第二次给更新数据
              for (let i in pushObj.data) {
                let arr = _this.collectionList;
                arr.forEach((item, index) => {
                  if (item.key == i) {
                    _this.$set(
                      _this.collectionList[index],
                      "data",
                      pushObj.data[i].data
                    );
                    _this.$set(
                      _this.collectionList[index],
                      "createTime",
                      pushObj.data[i].createTime
                    );
                  }
                });
              }
            }
          });
        }
      });

      _this.socket.on("disconnect", function () {
        console.log("已经下线");
      });
    },
    openLineChart(item) {
      let _this = this;
      _this.sensorTypeName = item.name;
      _this.sensorUnitType = item.unit;
      _this.$api.slbkOldTree
        .getTreechart(_this.baseData.register, item.key)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.linerChartShow = true;
            _this.chartData.columns = ["日期", "数值"];
            _this.chartData.rows = [];
            let NewObject = {};

            for (let i = 0; i < res.data.length; i++) {
              NewObject = {
                日期: res.data[i].time,
                数值: res.data[i].data,
              };
              _this.chartData.rows.push(NewObject);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    closeLinerChart() {
      this.linerChartShow = false;
    },
    //点击全屏进行跳转
    jumpUrl() {
      let jumpUrl = window.location.protocol + "//" + window.location.host + "";
      let timestamp = Date.parse(new Date());
      if (this.clientType == "android") {
        //android
        window.android.getInfo(
          105,
          "" +
            jumpUrl +
            "/slbktest/dhome-lzz-lzt-h5/#/monitorVideo?commonId=" +
            this.baseData.register +
            ""
        );
      } else {
        //IOS
        window.webkit.messageHandlers.getJumpUrl.postMessage(
          "" +
            jumpUrl +
            "/slbktest/dhome-lzz-lzt-h5/#/monitorVideo?commonId=" +
            this.baseData.register +
            "&token=" +
            this.userToken +
            "&time=" +
            timestamp +
            ""
        );
      }
    },
  },

  watch: {
    param: {
      handler: function () {
        let _this = this;
        this.showVedio = false;
        this.videoUrl = null;
        this.baseData = {};
        _this.monitorId = _this.param.id;
        _this.getMonitorDetail(true);
      },
      deep: true,
    },
  },
  beforeDestory() {
    this.baseData.deviceParams = null;
    window.clearInterval(this.timer);
    this.timer = null;
  },
};
</script>
<style lang="less">
.monitorPage {
  width: 100%;
  height: 100%;
  position: relative;
  .monitorDetail {
    height: 100%;
    overflow-y: scroll;
    background-color: #fff;
    h4.ggTit {
      position: relative;
      border-bottom: 1px solid #f6f6f6;
      line-height: 45px;
      padding: 0 20px;
      font-weight: 700;
      color: #333;
      font-size: 14px;
      z-index: 10;
      background-color: #fff;
      span {
        font-weight: 400;
        color: #4bc08a;
        font-size: 12px;
      }
    }
    .ggTit::before {
      content: "";
      position: absolute;
      width: 3px;
      height: 18px;
      background: #37c375;
      top: 13px;
      left: 12px;
    }
    .videoBox {
      width: 100%;
      height: 220px;
      .mySelfVideo {
        width: 100%;

        position: relative;
        .vjs-big-play-button {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
        }
      }
    }
    .sensorBox {
      width: 100%;
      margin-top: 10px;
      overflow-x: scroll;
      overflow-y: hidden;
      margin-bottom: 30px;
      ul {
        width: 100%;

        display: flex;
        &::-webkit-scrollbar {
          display: none;
        }
        .sensorItem {
          flex: 1;
          height: 80px;
          box-sizing: border-box;
          padding: 10px 10px;
          background-color: #37c375;
          margin: 0 8px;
          border-radius: 6px;
          -webkit-border-radius: 6px;
          -moz-border-radius: 6px;
          p {
            width: 150px;
            font-size: 16px;
            color: #fff;
            font-weight: bold;
            margin: 3px 0;
            span {
              display: inline-block;
              font-size: 16px;

              text-align: center;
            }
            em {
              font-size: 14px;
            }
          }
          p:nth-child(2) {
            padding-left: 20%;
          }
          p:last-child {
            font-weight: 400;
            text-align: right;
            font-size: 12px;
          }
        }
      }
    }
  }
  .nonePage {
    width: 120px;
    height: 150px;
    position: absolute;
    left: 50%;
    margin-left: -60px;
    top: 50%;
    margin-top: -75px;

    img {
      display: block;
      max-width: 100px;
      max-height: 100px;
      margin: 0 auto;
    }

    p {
      margin-top: 10px;
      text-align: center;
      color: #5c5d5d;
      font-size: 16px;
    }
  }
  // 折线图弹框样式
  .linePopup {
    width: 100%;
    height: 100%;
    background-color: #fff;

    z-index: 9999 !important;
    position: absolute;
    top: 0;
    left: 0;
    overflow-y: scroll;
    .closeBtn {
      position: absolute;
      top: 10px;
      right: 16px;
      font-size: 25px;
      color: #666;
      z-index: 10001;
    }
    .chartPage {
      width: 100%;
      height: 100%;
      padding-top: 15px;
      position: relative;
      .chartTit {
        width: 100%;
        font-size: 16px;
        color: #4bc08a;
        text-align: center;
        line-height: 1.6;
      }
      .linerMain {
        width: 365px;
        height: 350px;
        position: relative;
        .ydw {
          position: absolute;
          top: 20px;
          left: 16px;
          color: #333;
        }
        .xdw {
          position: absolute;
          bottom: 85px;
          right: 0;
          color: #333;
        }
      }
    }
  }
  .linePopup.smallLinePopup {
    .chartPage {
      .linerMain {
        width: 365px;
        height: 350px;
      }
    }
  }
}
</style>